export default import.meta.ROLLUP_FILE_URL_zX_ndPAVeiV4R08lY9$Vjg